/**
 * @function v3sHtmlfragment
 * @memberOf v3sWbtPlayerApp:page:elements
 * @description
 * Copies the content of the Htmlfragment into the body element of the content page
 */
angular.module('v3sWbtPlayerApp').directive('v3sHtmlfragment', function () {
    return {
        restrict: 'E',
        require: '^v3sDocument',
        scope: {
            id: '@'
        },
        link: function (scope, element, attrs, docCtrl) {
            if (!!scope.id) {
                docCtrl.addElement(element);
            }
        }
    }
});
